import * as React from 'react';
import { filter as _filter } from 'lodash';
import { connect } from 'react-redux';
import { LocalizeState, AvailableLanguage, selectLanguage } from 'src/api';
import { UserDataBaseModel } from 'franke-trough-dependencies';
import { Dropdown, DropdownItem, DropdownToggle } from 'reactstrap';
import { find as _find } from 'lodash';
import DropdownMenu from 'reactstrap/lib/DropdownMenu';
import { RequestApiResult, requestAPIActions, IsAuthentificatedState } from 'loopback-react-request';

import './SelectLanguage.scss';
import '../../../assets/sass/theme/dropdown/dropdown-select.scss';

export interface SelectLanguageProps {
  authenticator: IsAuthentificatedState;
  dispatch: any;
  language: LocalizeState['language'];
  userData: RequestApiResult<UserDataBaseModel>;
}

export interface SelectLanguageState {
  dropdownOpen: boolean;
}

export class SelectLanguagePartial extends React.Component<SelectLanguageProps, SelectLanguageState> {
  constructor(props: SelectLanguageProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
    };
  }

  public render() {
    const { available, selected } = this.props.language;
    const selectedLanguage = _find(available, (item: AvailableLanguage) => item.extendedCode === selected);
    
    return (
      <div className="partial-select-language">
        <Dropdown
          className="dropdown-select" 
          isOpen={this.state.dropdownOpen} 
          toggle={this.toggle} 
        >
          <DropdownToggle disabled={!this.isDropDownEnabled} className="mt-3 dropdown-toggle">
            {selectedLanguage && selectedLanguage.name}
          </DropdownToggle>
          <DropdownMenu>
            {available && available.map((item, index) => {
              const key = `select_language_dropdown_${index}`;
              return (
                <DropdownItem 
                  key={key} 
                  disabled={!item.enabled || item.extendedCode === selected}
                  onClick={() => this.handleClick(item.extendedCode)}
                >
                  {item.name}
                </DropdownItem>
              );
            })}
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }

  private get isDropDownEnabled(): boolean {
    const { available } = this.props.language;
    const count = _filter(available, lang => lang.enabled === true).length;
    return count > 1 ? true : false;
  }

  private handleClick(extendedCode: AvailableLanguage['extendedCode']) {
    const { authenticator, language, userData } = this.props;
    const { selected } = language;
    const { loaded, result } = userData;
    if (loaded && result) {
      if (result.lang !== extendedCode && authenticator.accessToken) {
        result.lang = extendedCode;
        this.props.dispatch(requestAPIActions.load(
          'userData', 
          {
            url: `/Users/${authenticator.accessToken.userId}/userData`,
            options: {
              method: 'PUT',
              data: result,
            }
          }, 
          true
        ));
      }
    } else {
      if (selected !== extendedCode) {
        this.props.dispatch(selectLanguage(extendedCode));
      }
    }
  }

  private toggle() {
    this.setState({dropdownOpen: !this.state.dropdownOpen});
  }
}

interface StateProps {
  authenticator: IsAuthentificatedState;
  localize: LocalizeState;
  userData: RequestApiResult<UserDataBaseModel>;
}

export const SelectLanguage = connect((state: StateProps) => ({
  authenticator: state.authenticator,
  language: state.localize.language,
  userData: state.userData,
}))(SelectLanguagePartial);

export default SelectLanguage;
